import { Link, Outlet, useLocation } from "react-router-dom";
import { DefaultFeatureFlags, isFeatureEnabled } from "../utils/featureFlags";
import { cn } from "@/utils/cn";
import { Button } from "@/components/atoms/Button";
import { ButtonBuilder } from "@/components/atoms/Button/ButtonBuilder";
import Makers from '../assets/makers.svg';

export const AuthLayout = () => {
  const location = useLocation();
  const useNeumorphism = isFeatureEnabled(DefaultFeatureFlags.USE_NEUMORPHISM);
  const loginButton = new ButtonBuilder()
    .setVariant('primary')
    .setSize('sm')
    .setNeumorph(useNeumorphism)
    .setChildren('Login')
    .build();

  const isAuthRoot = location.pathname === "/auth";

  return (
    <div>
      {isAuthRoot && (
        <div className="flex justify-end p-4">
          <Link to="/auth/login">
            <Button {...loginButton} />
          </Link>
        </div>
      )}
      <div className="h-screen flex items-center justify-center bg-white dark:bg-gray-900 p-4">
        <div
          className={cn(
            "w-full max-w-md px-8 py-6 rounded-xl",
            useNeumorphism
              ? "shadow-neumorph"
              : "bg-white dark:bg-gray-800 shadow-lg"
          )}
        >
          <div className="flex text-center mb-4 items-center justify-center">
            <img src={Makers} alt="Logo" className='w-44' />
          </div>

          <Outlet />

          <div className="pt-2 mt-4 text-center text-sm text-gray-500 border-t border-gray-200 dark:border-gray-700">
            &copy; {new Date().getFullYear()} Makers Solutions. All rights reserved.
          </div>
        </div>
      </div>
    </div>
  );
};
